import script from "./HorseRacingFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./HorseRacingFrame.vue?vue&type=script&setup=true&lang=js"

import "./HorseRacingFrame.vue?vue&type=style&index=0&id=c03aeb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c03aeb66"]])

export default __exports__